import { AppBootstrapProvider } from '@renderer/app/providers/app-bootstrap-provider';
import { AppRouter } from '@renderer/app/routes';

export function App(): JSX.Element {
  return (
    <AppBootstrapProvider>
      <AppRouter />
    </AppBootstrapProvider>
  );
}
